export default __webpack_public_path__ + "pgnv-assets/b069e38bd85cca00883f4dc89a5d018a.svg";